import gql from "graphql-tag";

const DEVICE_UPDATE_STATE_FIELDS = `
  status
  currentCommit
  osVersion
  blockedReason
  lastHeartbeatAt
  requestedAt
  requestedBy
`;

// Seeds the card on mount. The subscription below keeps it live, but a client that
// arrives between two changes would otherwise have nothing to show.
export const DEVICE_UPDATE_STATE_QUERY = gql`
  query {
    deviceUpdateState {
      ${DEVICE_UPDATE_STATE_FIELDS}
    }
  }
`;

export const SUBSCRIBE_TO_DEVICE_UPDATE_STATE = gql`
  subscription {
    subscribeToDeviceUpdateState {
      ${DEVICE_UPDATE_STATE_FIELDS}
    }
  }
`;

export const REQUEST_DEVICE_UPDATE_MUTATION = gql`
  mutation {
    requestDeviceUpdate {
      ${DEVICE_UPDATE_STATE_FIELDS}
    }
  }
`;

// Only the role and the id: whether the button is enabled depends on the user being
// an admin or the operator currently in command.
export const UPDATE_CURRENT_USER_QUERY = gql`
  query {
    getCurrentUser {
      id
      role
    }
  }
`;
